import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import Button from '../../atoms/Button';
import { Counter } from '../../atoms/Counter';
import { InboxHeaderProps } from './InboxHeader.types';

export const InboxHeader = ({
  unreadCount,
  microcopy,
  onMarkAllAsRead,
  className = '',
}: InboxHeaderProps) => {
  const hasUnread = !!unreadCount;

  return (
    <div
      className={c(
        'flex h-11 w-full justify-between rounded-t-lg bg-grey-850 pb-1 pl-4 pr-3 pt-2',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <div className="text-base font-medium leading-6 tracking-[-0.176px] text-grey-100">
          {microcopy.notifications}
        </div>
        {hasUnread && (
          <Counter
            counter={unreadCount}
            ariaLabel={interpolateStringWithData(
              microcopy.unreadCountAriaLabel,
              { count: unreadCount }
            )}
          />
        )}
      </div>
      {hasUnread && (
        <Button.v2
          className="normal-case text-blue"
          variant="dark-tertiary"
          size="xsmall"
          onClick={onMarkAllAsRead}
        >
          {microcopy.markAllAsRead}
        </Button.v2>
      )}
    </div>
  );
};
